import type { ValueOf } from 'cpool-utils';

export const LEAD_LIST_ROW_HIGHLIGHT = {
    DUPLICATE: 'duplicate',
    PARTNER: 'partner',
    SOURCE: 'source',
    STATUS: 'status',
} as const;

// Inset shadow instead of border-l so the indicator takes no layout space when hidden
export const LEAD_LIST_ROW_HIGHLIGHT_INDICATOR_CLASS =
    '[&>td:first-child]:shadow-[inset_4px_0_0_theme(colors.blue.text)]';

export type LeadListRowHighlightKey = ValueOf<typeof LEAD_LIST_ROW_HIGHLIGHT>;
export type LeadListRowHighlight = false | LeadListRowHighlightKey;
